import Repository from "./Repository";

const CREATE = "/create";
const DELETE = "/delete";
const EDIT = "/edit";
const GET_ALL = "/getall";
const GET = "/get";
const GET_PARTNER = "/getpartner";
const CREATE_PARTNER = "/createpartner";
const DELETE_PARTNER = "/deletepartner";
const EDIT_PARTNER = "/editpartner";
const GET_WORKSHOP = "/getworkshop";
const CREATE_WORKSHOP = "/createworkshop";
const DELETE_WORKSHOP = "/deleteworkshop";
const EDIT_WORKSHOP = "/editworkshop";
const GET_BANNER = "/getbanner";
const CREATE_BANNER = "/createbanner";
const DELETE_BANNER = "/deletebanner";
const EDIT_BANNER = "/editbanner";
const CREATE_HOME_BANNER = "/createhomebanner";
const EDIT_HOME_BANNER = "/edithomebanner";
const GET_ALL_HOME_BANNER = "/gethomebanner";
const DELETE_HOME_BANNER = "/deletehomebanner";
const CREATE_REG_FORM = "/regform/createregform";
const CREATE_CARE_PROFS = "/create";
const GET_CARE_PROFS = "/get";
const GET_APP_FORM = "/get";
const CREATE_APP_FORM = "/add";
const DELETE_APP_FORM = "/delete";
const GET_DONORS = "/get";
const CREATE_DONORS = "/add";
const UPDATE_DONORS = "/update";
const DELETE_DONORS = "/delete";
const DONORS_TYPE = "/donorType";

const GET_WISHES = "/getwishes";
const ADD_WISHES = "/addwishes";
const EDIT_WISHES = "/editwishes";
const DELETE_WISHES = "/deletewishes";

export default {
  create(payload) {
    return Repository.post(transformRoutecard(CREATE), payload);
  },
  delete(payload) {
    return Repository.post(transformRoutecard(DELETE), payload);
  },
  edit(payload) {
    return Repository.post(transformRoutecard(EDIT), payload);
  },
  get_all(payload) {
    return Repository.post(transformRoutecard(GET_ALL), payload);
  },

  get(payload) {
    return Repository.post(transformRoutecard(GET), payload);
  },
  createpartner(payload) {
    return Repository.post(transformRoutepartner(CREATE_PARTNER), payload);
  },
  deletepartner(payload) {
    return Repository.post(transformRoutepartner(DELETE_PARTNER), payload);
  },
  editpartner(payload) {
    return Repository.post(transformRoutepartner(EDIT_PARTNER), payload);
  },
  getpartner(payload) {
    return Repository.get(transformRoutepartner(GET_PARTNER), payload);
  },
  createworkshop(payload) {
    return Repository.post(transformRouteworkshop(CREATE_WORKSHOP), payload);
  },
  deleteworkshop(payload) {
    return Repository.post(transformRouteworkshop(DELETE_WORKSHOP), payload);
  },
  editworkshop(payload) {
    return Repository.post(transformRouteworkshop(EDIT_WORKSHOP), payload);
  },
  getworkshop(payload) {
    return Repository.get(transformRouteworkshop(GET_WORKSHOP), payload);
  },
  createbanner(payload) {
    return Repository.post(transformRoutebanner(CREATE_BANNER), payload);
  },
  deletebanner(payload) {
    return Repository.post(transformRoutebanner(DELETE_BANNER), payload);
  },
  editbanner(payload) {
    return Repository.post(transformRoutebanner(EDIT_BANNER), payload);
  },
  getbanner(payload) {
    return Repository.get(transformRoutebanner(GET_BANNER), {
      params: payload,
    });
  },
  createhomebanner(payload) {
    return Repository.post(
      transformRoutehomebanner(CREATE_HOME_BANNER),
      payload
    );
  },
  edithomebanner(payload) {
    return Repository.post(transformRoutehomebanner(EDIT_HOME_BANNER), payload);
  },
  getallhomebanner(payload) {
    return Repository.get(
      transformRoutehomebanner(GET_ALL_HOME_BANNER),
      payload
    );
  },
  deletehomebanner(payload) {
    return Repository.post(
      transformRoutehomebanner(DELETE_HOME_BANNER),
      payload
    );
  },
  createregform(payload) {
    return Repository.post(transformRouteregform(CREATE_REG_FORM), payload);
  },

  createCareProf(payload) {
    return Repository.post(transformRouteCareProfs(CREATE_CARE_PROFS), payload);
  },

  getCareProfs(payload) {
    return Repository.post(transformRouteCareProfs(GET_CARE_PROFS), payload);
  },

  getAppForm(payload) {
    return Repository.get(transformRouteGetAppForm(GET_APP_FORM), {
      params: payload,
    });
  },
  createAppForm(payload) {
    return Repository.post(transformRouteGetAppForm(CREATE_APP_FORM), payload);
  },
  deleteAppForm(payload) {
    return Repository.post(transformRouteGetAppForm(DELETE_APP_FORM), payload);
  },

  getDonor(payload) {
    return Repository.get(transformRouteDonor(GET_DONORS), {
      params: payload,
    });
  },
  createDonor(payload) {
    return Repository.post(transformRouteDonor(CREATE_DONORS), payload);
  },
  updateDonor(payload) {
    return Repository.post(transformRouteDonor(UPDATE_DONORS), payload);
  },
  deleteDonor(payload) {
    return Repository.post(transformRouteDonor(DELETE_DONORS), payload);
  },

  donorType(payload) {
    return Repository.get(transformRouteDonor(DONORS_TYPE), {
      params: payload,
    });
  },

  getWishes(payload) {
    return Repository.post(transformRouteWishes(GET_WISHES), payload);
  },
  addWishes(payload) {
    return Repository.post(transformRouteWishes(ADD_WISHES), payload);
  },
  editWishes(payload) {
    return Repository.post(transformRouteWishes(EDIT_WISHES), payload);
  },
  deleteWishes(payload) {
    return Repository.post(transformRouteWishes(DELETE_WISHES), payload);
  },
};

const transformRouteregform = (route) => {
  return `/services${route}`;
};
const transformRoutecard = (route) => {
  return `/services/card${route}`;
};

const transformRoutepartner = (route) => {
  return `services/partner${route}`;
};

const transformRouteworkshop = (route) => {
  return `/services/workshop${route}`;
};

const transformRoutebanner = (route) => {
  return `/services/banner${route}`;
};

const transformRoutehomebanner = (route) => {
  return `/services/homebanner${route}`;
};

const transformRouteCareProfs = (route) => {
  return `/services/careProf${route}`;
};
const transformRouteGetAppForm = (route) => {
  return `/services/getApp${route}`;
};
const transformRouteDonor = (route) => {
  return `/services/donor${route}`;
};
const transformRouteWishes = (route) => {
  return `/wishes${route}`;
};
